import AccountVerifiedBadge from "./AccountVerifiedBadge";

export default AccountVerifiedBadge;
